import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NicaFormComponent } from '../../nica-form/nica-form.component';
//import { getVariabili } from '../../../services/templates/esporta';
import { DxDataGridComponent, DxListComponent, DxTextBoxComponent } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import { ModelliStampaService } from '../../../services/modelli-stampa.service';
import { DxoItemDraggingComponent } from 'devextreme-angular/ui/nested';
import { map, retry } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
import DataSource from 'devextreme/data/data_source';
import fx from 'devextreme/animation/fx';
import { NgxSpinnerService } from 'ngx-spinner';
import CustomStore from 'devextreme/data/custom_store';
import ArrayStore from 'devextreme/data/array_store';
import { filter } from 'rxjs-compat/operator/filter';
import notify from 'devextreme/ui/notify';
import { Subject } from 'rxjs';
import { Utenteservice } from '../../../services/utente.service';
import { R } from '@angular/cdk/keycodes';
import { RemoveTextBetweenCharactersPipe } from '../../../pipes/removeTextBetweenCharacters.pipe';
import { eventGrid } from '../../../class/userinterface';
import { UtilityService } from '../../../services/utility.service';
import { GetFilterService } from '../../../services/get-filter.service';

export interface IColonnaExcel {

}


@Component({
  selector: 'app-excel-exporter',
  templateUrl: './excel-exporter.component.html',
  styleUrls: ['./excel-exporter.component.css'],
  providers: [RemoveTextBetweenCharactersPipe]
})
export class ExcelExporterComponent implements OnInit, OnDestroy, AfterViewInit {

  isLoaded: boolean = false;

  //@Input() colonne:any[];


  @ViewChild(NicaFormComponent, { static: false }) strutturaExcelForm: NicaFormComponent;
  @ViewChild(DxListComponent, { static: false }) listaVariabili: DxListComponent;
  @ViewChild(DxoItemDraggingComponent, { static: false }) itemDragging: DxoItemDraggingComponent;
  @ViewChild(DxDataGridComponent, { static: false }) grigliaAppoggio: DxDataGridComponent;
  @ViewChild(DxDataGridComponent, { static: false }) grigliaVariabiliScelte: DxDataGridComponent;

  @ViewChild(DxTextBoxComponent, { static: false }) textBoxVariabile: DxTextBoxComponent;



  @Output('emettiClick') emettiClick: EventEmitter<any> = new EventEmitter<any>();

  isFileAppenaScaricato: Subject<boolean> = new Subject<boolean>();

  /** Id Categoria per la Stampa (es. 300) */
  @Input() idCategoriaModello?: string;

  variabiliDisponibiliDS: DataSource;
  /** Percorso al quale ne verrà contattato il DataTable (es. MovimentoRifiuti/GetDataTable) */
  @Input() api: string;
  @Input() advancedXlsExportAddWorksheet: Array<Record<string, any>> = [];
  @Input() advancedXlsExportAddWorksheetName: string = 'Informazioni aggiuntive';
  @Input() addFilterColumnToAdvancedXls: boolean = false;
  @Input() wingap: boolean = true;
  @Input() filter?: string;
  @Input() customApiAdvancedXls: string | null = null;

  @Input() nascondiCelleRipetuteColonneOrdinate: boolean = true;
  @Input() data: any[];

  @Input() itemData?: any;

  variabiliDisponibili: any[] = [];

  disabilitaVariabiliScelte: boolean = false;

  variabiliScelte: any[] = [];
  colonneDaOrdinare?: any[] = [];

  elencoSezioni: any[];

  dati: any[] = [];

  @Input() toolbarButtons: any[] = [];
  @Input() skip: boolean = false;


  bottoneCercaVariabili: any;
  idUtenteConnesso?: number;



  constructor(private modelliStampaSerice: ModelliStampaService, private http: HttpClient, private spinner: NgxSpinnerService, private utenteService: Utenteservice, private utility: UtilityService, private getFilter: GetFilterService) {


  }
  ngAfterViewInit(): void {

    setTimeout(() => {

      let editor = this.strutturaExcelForm.formEdit.instance.getEditor('listaOrdinamento');

      //console.warn(editor);

      editor.option('dataSource', this.variabiliScelte);


    }, 1000);

  }

  ngOnDestroy(): void {
    (fx as any).off = false; //Rimette animazioni
  }


  /*
    onAdd1(e) {
      console.log(e);
  
      this.variabiliScelte.push(e.itemElement.outerText);
      e.toData.splice(e.toIndex, 0, e.itemData);
     
    }
  
    onRemove1(e) {
      
      (this.sottogruppi[0] as any)['items'].splice(e.fromIndex,1);
    }
  */

  onAdd(e) {

    //console.warn('onAdd:',e);

    if (this.disabilitaVariabiliScelte == true)
      return;

    /*
    for(let group of e.fromData){

      

        if(group.id ==e.itemData.id){

          e.itemData['key'] = group.key

          break;
        }

      }
      */


    e.toData.splice(e.toIndex, 0, e.itemData);
    /*   //(this.sottogruppi[0] as any)['items'].splice(e.fromIndex,1);
  
   
      
    */
    setTimeout(
      () => {

        let editor = this.strutturaExcelForm.formEdit.instance.getEditor('listaOrdinamento');

        //console.warn(editor);

        editor.option('dataSource', this.variabiliScelte);

      }, 500
    );

    ///e.component.option('items',e.itemData);

  }

  onRemove(evt) {

    //.warn(evt);


    let store = this.variabiliDisponibiliDS.store();

    store.remove(evt.data.id).then(
      (key) => {

        //console.warn('elemento eliminato',key);

        this.listaVariabili.instance.reload();
        this.itemDragging.instance.reload();

        setTimeout(
          () => {

            let editor = this.strutturaExcelForm.formEdit.instance.getEditor('listaOrdinamento');

            //console.warn(editor);

            editor.option('dataSource', this.variabiliScelte);

          }, 500
        );
      }
    );






    /*
    evt.fromData.splice(evt.fromIndex, 1);

    //Inidice Sezione
    let sezioneIndex = evt.fromData.findIndex(
      (item)=>{
        return item.key == evt.itemData.key
      }
    );


    let itemIndex = evt.fromData[sezioneIndex].items.findIndex(
      (item)=>{
        item.id == evt.itemData.id
      }
    );

    evt.fromData[sezioneIndex].items.splice(itemIndex,1);
      */

  }



  onReorder(e) {

    //console.warn(e);

    const toIndex = e.toIndex;
    const fromIndex = e.fromIndex;

    this.variabiliScelte.splice(fromIndex, 1);
    this.variabiliScelte.splice(toIndex, 0, e.itemData);
  }

  onDragStart(e) {
    //console.log('onDragStart',e);

    //e.itemData = e.fromData[e.fromIndex];
    //(fx as any).off=true;

    e.itemData = e.component.getItemByIndex(e.fromIndex);

    //console.log('onDragStart',e);

  }

  async ngOnInit(): Promise<void> {

    //this.onAdd1 = this.onAdd1.bind(this);
    //this.onRemove1 = this.onRemove1.bind(this);
    //(fx as any).off=true;



    setTimeout(
      async () => {

        //console.log(this.colonne);

        let arrayVariabili = (await this.modelliStampaSerice.getVariabili(this.idCategoriaModello));//.reverse();

        let arraySezioni = (await this.modelliStampaSerice.getSezioniByCategoria(this.idCategoriaModello)).filter((i) => i.id != 820);
        this.elencoSezioni = arraySezioni;



        let i = 0;

        for (let sezione of arraySezioni) {

          //console.warn(sezione);

          for (let variabile of arrayVariabili) {

            if (variabile.idSezione == sezione.id) {

              variabile['group'] = (sezione.descrizione as string).replace(/[�]/g, 'à');
              variabile['groupIndex'] = i;
              //È presente già un ID (tipo stringa)

              this.variabiliDisponibili.push(variabile);

            }
          }

          i++;

        }


        this.onAdd = this.onAdd.bind(this);
        this.onReorder = this.onReorder.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onDragStart = this.onDragStart.bind(this);

        this.bottoneCercaVariabili = { icon: 'fas fa-search', onClick: () => { this.onSearch(this.textBoxVariabile.value) } };

        this.idUtenteConnesso = parseInt(this.utenteService.InfoDatiUtenteConnesso.idAccount);


        //console.warn(this.variabiliDisponibili);

        let store = new ArrayStore({
          data: this.variabiliDisponibili,
          key: 'id',
        });



        this.variabiliDisponibiliDS = new DataSource({
          store: store,
          key: 'id',
          //sort:  [{ selector: "idSezione", desc: true }],
          searchExpr: 'descrizione',
          group: 'group',
          searchOperation: 'contains',

        })





        if (this.itemData !== undefined && this.itemData !== null && this.itemData.method)
          if (this.itemData.method.toLowerCase() == 'put' || this.itemData.isDuplicating == true) {

            //console.warn(this.itemData);
            if ((this.itemData.method.toLowerCase() == 'post' && this.itemData.isDuplicating == true))
              this.strutturaExcelForm.formEdit.instance.updateData('descrizione', undefined);
            else
              this.strutturaExcelForm.formEdit.instance.updateData('descrizione', this.itemData.descrizione);

            if (this.itemData.isDuplicating == true) {

              let buttonElements = document.getElementsByClassName('salvaButtonExcelExporter');

              /*
              for(let i = 0 ; i < buttonElements.length ; i++){
  
  
  
                console.warn('buttonElement',buttonElements.item(i));
  
  
              }
              */



            }

            this.variabiliScelte = this.itemData.listaVariabili;

            //console.warn('SCELTE:',this.variabiliScelte);

            this.strutturaExcelForm.onRadioGroupValueChanged({ value: this.itemData.tipoStruttura }, 'tipoStruttura');

            /*
            if(this.itemData.isDuplicating == true)
              console.log('testing');
            else 
            */
            if (this.itemData.tipoStruttura !== 1) {

              //console.warn(this.itemData)

              this.strutturaExcelForm.disableRadioGroup('tipoStruttura');

            }




            this.strutturaExcelForm.formEdit.instance.itemOption('listaOrdinamento', 'items', this.variabiliScelte);


            setTimeout(
              () => {

                let editor = this.strutturaExcelForm.formEdit.instance.getEditor('listaOrdinamento');

                //console.warn(editor);

                editor.option('dataSource', this.variabiliScelte);

                /*
                let selectedItems = this.itemData.listaOrdinamento.map(
                  (item)=>{
                    return item.idFieldDTB
                  }
                )
                */
                let selectedItems = this.itemData.listaOrdinamento;

                this.strutturaExcelForm.formEdit.instance.updateData('listaOrdinamento', this.itemData.listaOrdinamento)

                //console.warn('SELECTED:',selectedItems);

                editor.option('value', selectedItems);

              }, 500
            );

            /*
            if(this.itemData.tipoStruttura == 2 && this.idUtenteConnesso !== this.itemData.idUtenteCreator){
  
              //this.strutturaExcelForm.formEdit.instance.itemOption('descrizione','disabled',true);
  
              //this.strutturaExcelForm.formEdit.instance.itemOption('listaOrdinamento','disabled',true);
              
              let editorDescrizione = this.strutturaExcelForm.formEdit.instance.getEditor('descrizione');
  
              editorDescrizione.option('disabled',true);
  
  
              let editorListaOrdinamento = this.strutturaExcelForm.formEdit.instance.getEditor('listaOrdinamento');
  
              editorListaOrdinamento.option('disabled',true);
  
  
              this.bottoneCercaVariabili['disabled'] = true;
  
              this.listaVariabili.disabled = true;
  
              this.listaVariabiliScelte.disabled = true;
  
              this.textBoxVariabile.disabled = true;
  
              this.disabilitaVariabiliScelte = true;
  
  
              this.toolbarButtons[1].icon='copy';
              this.toolbarButtons[1].event='duplica';
              this.toolbarButtons[1].text='Duplica';
  
  
            }
          */
          }




        /*
        setTimeout(
          async()=>{
            for(let i = 0 ;  i < arraySezioni.length ; i++ ){
              
              await this.listaVariabili.instance.collapseGroup(i);
              
            }
            
            
          },100
          )
        */

        //console.log(this.variabiliDisponibili);

        setTimeout(
          async () => {
            this.isLoaded = true;

            await this.grigliaVariabiliScelte.instance.refresh();

          }, 200
        )

      }, 200);




  }


  async onValueChanged(evt) {


    if (evt.value === '' && evt.event.type.toLowerCase().includes('click')) {
      await this.onSearch('');
    }

  }




  async onSearch(evt: any, testo?: string) {
    //console.warn(evt);


    if (typeof evt == 'string') {


      this.variabiliDisponibiliDS.searchValue(evt);

      await this.variabiliDisponibiliDS.load();


      /*
      let gruppiTrovati = await this.variabiliDisponibiliDS.load();  


      
      for(let i = 0; i< gruppiTrovati.length;i++){

        this.listaVariabili.instance.expandGroup(i);

      }
      */

      return;
    }
    if (evt.event.key.toLowerCase() == 'enter') {

      //console.warn(testo);

      this.variabiliDisponibiliDS.searchValue(testo);

      await this.variabiliDisponibiliDS.load();

      /*
      let gruppiTrovati = await this.variabiliDisponibiliDS.load();  


    
      for(let i = 0; i< gruppiTrovati.length;i++){
 
        this.listaVariabili.instance.expandGroup(i);
 
      }
      */

      return;

    }



  }

  onGroupRendered(evt) {

    return;

    if (this.isLoaded == false)
      evt.component.collapseGroup(evt.groupIndex);

  }

  async gestisciEventoPulsante(evt: any) {


    /*
    if (evt.event == 'sfogliaVariabili') {

      await this.listaVariabili.instance.expandGroup(this.esportaForm.dataSet["sottoGruppi"]);



      this.listaVariabili.instance.scrollToItem(this.esportaForm.dataSet["sottoGruppi"]);

      return;
    }
    */


    if (evt.event == 'trasferisciColonne') {

      let itemSelezionati = this.listaVariabili.selectedItems;


      //console.warn(itemSelezionati)





      for (let itemSelezionato of itemSelezionati) {

        //console.log(itemSelezionato);


        for (let item of itemSelezionato.items) {

          /*
          PER RIMUOVERE DALLE VOCI DISPONIBILI
          let store  = this.variabiliDisponibiliDS.store();

          await store.remove(item.id);
           
      
      
          this.listaVariabili.instance.reload();
          this.itemDragging.instance.reload();
          */
          this.variabiliScelte.push(item);



        }

      }



      setTimeout(
        () => {

          let editor = this.strutturaExcelForm.formEdit.instance.getEditor('listaOrdinamento');

          //console.warn(editor);

          editor.option('dataSource', this.variabiliScelte);

        }, 500
      );


      this.listaVariabili.selectedItems = [];
    }


    if (evt == 'generaExcel') {

      if (!this.variabiliScelte || this.variabiliScelte.length == 0) {

        alert('Esportare almeno una colonna!', 'Attenzione');

        return;

      }


      await this.spinner.show();


      /*
      let ris = this.variabiliScelte.map(
        (variabile) => variabile.idFieldDTB
      );

        */



      //Nel caso di Soggetti e Sedi (UL) andrò ad usare il nuovo metodo per dati aggregati
      if (this.api.toLowerCase() == 'soggetto') {


        if (this.filter == '?NostreAziende=S&' || this.filter == '?NostreAziende=S')
          this.filter = '?$filter=(sD_NsAzienda eq true)';
        else if (this.filter.split('&').length > 1)
          this.filter = '?' + this.filter.split('&')[1].replace(/id/g, 'sD_Id');



        this.api = 'SoggettoSede/GetAllSoggettiSedi';

      }

      if (this.api.toLowerCase() == 'sede') { //Unità Locali


        this.api = 'SoggettoSede/GetAllSoggettiSedi?IdSoggetto=';   //.replace(/[()]/g,''); //API + ID PADRE



        if (this.filter.includes('$filter'))  //Se le UL sono state filtrate
          this.filter = this.filter.replace(/[/]/g, '').replace(/[?]/g, '&').replace(/id/g, 'uL_Id');
        else
          this.filter = this.filter.replace(/[/]/g, '');


        /*
        if(this.filter.startsWith('(') && this.filter.endsWith(')'))
          this.filter = this.filter.replace(/[()]/g,'');
        */
      }

      //
      let env = this.wingap ? environment.BASE_API_URL : environment.BASE_API_URL_APIREST;
      // TODO da testare
      const headerFilter = () => {
        if (!this.addFilterColumnToAdvancedXls) return ''
        let filterColumn = this.getFilter.getFilter()
        if (!filterColumn) return ''
        filterColumn = filterColumn
          .replace(/(^|\&)?\$count=true(&|$)?/g, '')
          .replace(/(^|\&)?\$top=\d+(&|$)?/g, '')
          .replace(/(^|\&)?\$skip=\d+(&|$)?/g, '')
          .replace(/^&+|&+$/g, '').trim();
        return filterColumn
      }

      const url = (that) => {
        const header = headerFilter();
        const api = that.customApiAdvancedXls && that.customApiAdvancedXls !== '' ? that.customApiAdvancedXls : that.api;
        if (header === '' && that.filter) return api + (that.filter ? that.filter : '')
        if (!that.filter && header !== '') return `${api}?${header}`
        if (header !== '' && that.filter !== '') return `${api}${that.filter}&${header}`
        return api
      }
      // TODO da testare
      let call = await this.http.get<any>(env.concat(url(this))) //${this.colonnaDaOrdinare && this.colonnaDaOrdinare.length>0 ? '?$orderby='+this.colonnaDaOrdinare+' asc' : ''}
        .pipe(
          map((dati) => {
            if (!dati) return [];
            if (dati['items']) return dati['items']
            if (dati['data']) return dati['data']
            return dati;
          })
        )
        .toPromise();

      let dati = [];

      //Le variabili hanno le iniziali con lettera maiuscola quindi bisogna fare lo stesso
      for (let dato of call) {

        let tempObj = {};

        for (let key of Object.keys(dato)) {

          for (let variabile of this.variabiliScelte) {

            /*
            const capitalizedKey = key.charAt(0).toUpperCase()+key.substring(1,key.length-1);
  
            dato[capitalizedKey] = dato[key];
  
            delete dato[key];
            */

            if (variabile.idFieldDTB.toLowerCase() == key.toLowerCase()) {
              tempObj[variabile.idFieldDTB] = dato[key];
            }

          }

        }

        dati.push(tempObj);
      }


      this.dati = dati;


      //console.warn(dati);
      /*
        console.warn({
          dati:this.dati,
          variabiliScelte:this.variabiliScelte
        });
      */
      setTimeout(
        async () => {

          if (!this.skip)
            this.colonneDaOrdinare = this.strutturaExcelForm.formEdit.formData['listaOrdinamento'] ? this.strutturaExcelForm.formEdit.formData['listaOrdinamento'] : [];


          //console.warn('COLONNE DA ORDINARE',this.colonneDaOrdinare)

          this.grigliaAppoggio.instance.clearSorting();

          if (this.colonneDaOrdinare && this.colonneDaOrdinare.length > 0) {

            //console.log(this.colonneDaOrdinare);

            for (let colonnaDaOrdinare of this.colonneDaOrdinare) {

              this.grigliaAppoggio.instance.columnOption(colonnaDaOrdinare, 'sortOrder', 'asc');

            }


            setTimeout(
              async () => {
                let selectedRowsData = this.grigliaAppoggio.instance.getSelectedRowsData();
                if (selectedRowsData.length > 0) {
                  // Se ci sono righe selezionate, esporta solo quelle                
                  this.grigliaAppoggio.instance.exportToExcel(true);
                } else {
                  // Se non ci sono righe selezionate, esporta tutte le righe
                  this.grigliaAppoggio.instance.exportToExcel(false);
                }


              }, 500
            )

          } else {


            this.grigliaAppoggio.instance.exportToExcel(false);


          }


        }, 2000
      )


      /*
      this.emettiClick.emit((this.colonnaDaOrdinare) ?
        {
          ris,
          colonnaDaOrdinare: this.colonnaDaOrdinare.text
        }
        :
        ris
      );
      */


      return;

    }

    if (evt == 'annullaExcel') {

      this.emettiClick.emit(undefined);


      return;
    }
    // console.log(this.esportaForm.dataSet["sottoGruppi"]);
    if (evt == 'salva') {


      if (!this.variabiliScelte || this.variabiliScelte.length == 0) {

        alert('Selezionare almeno una colonna!', 'Attenzione');

        return;

      }

      if (!this.strutturaExcelForm.formEdit.instance.validate().isValid) {


        return;

      }

      let listaVariabili: any[] = [];

      /*
      for(let variabile of this.variabiliScelte){

        listaVariabili.unshift({
          idCategoria:variabile.idCategoria,
          idFieldDTB: variabile.idFieldDTB,
          descrizione:variabile.descrizione
        })

      }
      */

      listaVariabili = this.variabiliScelte.map(function (item) {
        delete item.group;
        delete item.groupIndex;
        return item;
      });


      if (this.strutturaExcelForm.formEdit.formData['listaOrdinamento'] && !this.skip)
        if (this.strutturaExcelForm.formEdit.formData['listaOrdinamento'].length > 0) {

          this.colonneDaOrdinare = [];

          for (let idFieldDTB of this.strutturaExcelForm.formEdit.formData['listaOrdinamento']) {

            let indexColonnaOrdinata = listaVariabili.findIndex(
              (variabile) => {
                return variabile.idFieldDTB == idFieldDTB
              }
            );

            if (indexColonnaOrdinata !== -1) {

              this.colonneDaOrdinare.push(listaVariabili[indexColonnaOrdinata]);

            }

          }

        }



      //console.warn(this.colonneDaOrdinare);

      let body = {
        idCategoriaModello: this.idCategoriaModello,
        descrizione: this.strutturaExcelForm.formEdit.formData['descrizione'],
        listaVariabili: listaVariabili,
        tipoStruttura: this.strutturaExcelForm.formEdit.formData['tipoStruttura'] ? this.strutturaExcelForm.formEdit.formData['tipoStruttura'] : 2,
        listaOrdinamento: this.colonneDaOrdinare
      }

      if (this.itemData['id'] && this.itemData.method.toLowerCase() == 'put')
        body['id'] = this.itemData['id'];
      //console.warn(body);

      try {

        if (this.itemData.method.toLowerCase() == 'post')
          await this.http.post(environment.BASE_API_URL.concat('StrutturaExcel'), body).toPromise();

        else if (this.itemData.id)
          await this.http.put(environment.BASE_API_URL.concat('StrutturaExcel/' + this.itemData.id), body).toPromise();

        notify({
          message: 'Struttura Excel salvata',
          height: 45,
          width: 250,
          position: 'center center'

        }, 'success', 3000);



        this.emettiClick.emit(undefined);


        return;

      } catch (err) {
        console.error('errore', err);
      }



    }

  }


  async onEliminazioneItem(evt) {


    //console.warn('onEliminazioneItem',evt);

    if (!evt.itemData)
      return;

    let store: ArrayStore = this.variabiliDisponibiliDS.store();

    /*
    if(!this.variabiliDisponibili.some(
      (item)=>{
        return evt.itemData.idFieldDTB == item.idFieldDTB
      }
    ))
    */
    if (evt.itemData.idFieldDTB) {


      await store.insert(evt.itemData);

      await this.variabiliDisponibiliDS.load();

    }

    this.listaVariabili.instance.reload();
    this.itemDragging.instance.reload();

  }

  onItemClick(evt) {

    //console.warn(evt);

    (fx as any).off = false;
  }



  async onEsportaXls(evt) {


    evt.cancel = true;

    let that = this;


    const ExcelJS = require('exceljs');

    const workbook = new ExcelJS.Workbook();


    let filename = this.strutturaExcelForm.formEdit.formData['descrizione'] ? this.strutturaExcelForm.formEdit.formData['descrizione'] : this.itemData['descrizione'] ? this.itemData['descrizione'] : 'Esportazione Senza Nome';

    filename = filename.replace(/[*?:\\/[\]]/g, '');

    const worksheet = workbook.addWorksheet(filename);



    exportDataGrid({
      component: evt.component,
      worksheet,
      autoFilterEnabled: true,
      keepColumnWidths: false,





      customizeCell: async (options) => {

        //console.log(options);

        const { gridCell } = options;
        const { excelCell } = options;



        excelCell.alignment = { horizontal: 'left' };

        if (gridCell.rowType == "header") {


          excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'fffbd6' } };
          excelCell.font = { color: { argb: '8b0000' }, underline: false };



        }

        if (typeof gridCell.value === "boolean" && !gridCell.value) {

          //gridCell.column.name
          ////console.log('gridCell',gridCell);
          ////console.log('excelCel',excelCell);

          worksheet.getCell(excelCell['_address']).value = 'No';


        }
        else if (typeof gridCell.value === "boolean" && gridCell.value) {

          worksheet.getCell(excelCell['_address']).value = 'Si';

        }


        if (gridCell.column.dataField == 'guidAccettazione') {

          if (worksheet.getCell(excelCell['_address']).value.toLowerCase() == 'invito')
            worksheet.getCell(excelCell['_address']).value = 'Iscrizione';
          else
            if (worksheet.getCell(excelCell['_address']).value.length > 0)
              worksheet.getCell(excelCell['_address']).value = 'In Attesa';
            else
              worksheet.getCell(excelCell['_address']).value = 'Confermata';


        }

        if (worksheet.getCell(excelCell['_address']).value !== null) {

          if (worksheet.getCell(excelCell['_address']).value.toLowerCase() == 'false') {

            worksheet.getCell(excelCell['_address']).value = 'No';


          }

          if (worksheet.getCell(excelCell['_address']).value.toLowerCase() == 'true') {

            worksheet.getCell(excelCell['_address']).value = 'Si';

          }
        }


        //if(worksheet.getCell(excelCell['_address']).value == worksheet.getCell(letteraCella.concat((numeroCella-1).toString())).value){

        //console.warn(excelCell)

        //console.warn(excelCell['_column']['_worksheet']['_rows'].length)
        /*
        const valoreCostante = worksheet.getCell(excelCell['_address']).value;

        /*
        console.log('kjkjlkj',{
          pippo:valoreCostante,
          pluto:worksheet.getCell(letteraCella.concat((numeroCella-1).toString()))['value']
        });

          //if(valoreCostante && (valoreCostante != worksheet.getCell(letteraCella.concat((numeroCella-1).toString()))['value']) && (worksheet.getCell(letteraCella.concat((numeroCella-1).toString()))['value'] == worksheet.getCell(letteraCella.concat((numeroCella-2).toString()))['value'])){
          
            let index = numeroCella;

            //console.warn(index);

            while(valoreCostante == worksheet.getCell(letteraCella.concat((index-1).toString()))['value']){


              console.warn({
                successivo:worksheet.getCell(letteraCella.concat((index+1).toString()))['value'],
                precedente:worksheet.getCell(letteraCella.concat((index-1).toString()))['value']
              })
            
             
              
              worksheet.getCell(letteraCella.concat((index).toString())).value=" ";
              
              if(valoreCostante == worksheet.getCell(letteraCella.concat((index+1).toString()))['value']){

                //console.warn('ciccia');
                worksheet.getCell(letteraCella.concat((index+1).toString())).value=" ";
              }

              index--;

            }
        */



        //}

        //A questo punto dovrò ciclare tutte le righe successive è mettere apici vuoi come valore se il value è uguale alla cella costante
        //for(let i = numeroCella ; i < that.griglia.instance)
        //  worksheet.getCell(excelCell['_address']).value= '';












        //Qui dovrò effettuare la trasformazione dei lookups in devExtreme e sostituirne i valori

        if (gridCell.column.lookup) {

          let lookups: any[] = (gridCell.column.lookup.dataSource as any[]);

          const displayExpr = gridCell.column.lookup.displayExpr;
          const valueExpr = gridCell.column.lookup.valueExpr;

          ////console.log(displayExpr);


          ////console.log(valueExpr);

          //console.table(lookups);

          for (let lookup of lookups) {

            if (lookup[`${valueExpr}`] === worksheet.getCell(excelCell['_address']).value) {

              worksheet.getCell(excelCell['_address']).value = lookup[`${displayExpr}`];

            }

          }
        }
      },

      // modifica adele




    }).then(() => {

      //console.warn(worksheet)        

      //console.warn(this.colonneDaOrdinare);


      let getSortedColumn = (): any => {
        const instance = this.grigliaAppoggio.instance;
        const allColumns = Array.from(Array(instance.columnCount()).keys()).map(index => instance.columnOption(index));


        return allColumns.filter(col => col.dataField != null && this.colonneDaOrdinare.some((colonnaDaOrdinare) => {
          return col.dataField == colonnaDaOrdinare
        }));
      }



      if (this.nascondiCelleRipetuteColonneOrdinate == true && this.colonneDaOrdinare.length > 0) {


        let listaOrdinamento: any[] = getSortedColumn();

        //console.log('COLONNE ORDINATE:',listaOrdinamento);

        if (listaOrdinamento && listaOrdinamento.length > 0) {

          for (let colonnaOrdinata of listaOrdinamento) {

            const righe = worksheet.getColumn(1);
            let righee = righe['_worksheet']['_rows'];


            let letteraOrdinata = '';

            for (let riga of righee) {

              for (let cella of riga['_cells']) {

                if (cella['_value']['model']['value'] == colonnaOrdinata.caption) {

                  letteraOrdinata = cella['_value']['model']['address'].replace(/([0-9])/g, '');

                  break;
                }


              }

              if (letteraOrdinata.length > 0)
                break;
            }

            //console.warn(righe['_worksheet']['_rows'].length);


            for (let i = 2; i < righe['_worksheet']['_rows'].length; i++) {

              //.replace(/ /g,'') .replace(/\s+/g, "")

              //if((worksheet.getCell(letteraOrdinata.concat(i.toString()))['value'] as string) && (worksheet.getCell(letteraOrdinata.concat((i-1).toString()))['value'] as string))

              if (!(worksheet.getCell(letteraOrdinata.concat(i.toString()))['value']) || !(worksheet.getCell(letteraOrdinata.concat((i - 1).toString()))['value']))
                continue;

              if ((worksheet.getCell(letteraOrdinata.concat(i.toString()))['value']) == (worksheet.getCell(letteraOrdinata.concat((i - 1).toString()))['value'] as string)) {

                let tempIndex = i + 1;

                if ((worksheet.getCell(letteraOrdinata.concat((tempIndex).toString()))['value']))
                  while ((worksheet.getCell(letteraOrdinata.concat(i.toString()))['value']) == (worksheet.getCell(letteraOrdinata.concat((tempIndex).toString()))['value'])) {

                    worksheet.getCell(letteraOrdinata.concat((tempIndex).toString()))['value'] = " // ";

                    tempIndex++;



                  }

                worksheet.getCell(letteraOrdinata.concat((i).toString()))['value'] = " // ";
              }

            }
          }
        }

      }

      worksheet.columns.forEach(function (column, i) {
        let maxLength = 0;
        column["eachCell"]({ includeEmpty: true }, function (cell) {
          var columnLength = cell.value ? cell.value.toString().length : 10;
          if (columnLength > maxLength) {
            maxLength = columnLength + 2;
          }
        });
        column.width = maxLength < 10 ? 10 : maxLength;
      });
      if (Array.isArray(this.advancedXlsExportAddWorksheet) && this.advancedXlsExportAddWorksheet.length > 0) {
        const name = () => {
          const nomeFile = workbook.getWorksheet()['_name'];
          return (this.advancedXlsExportAddWorksheetName && (nomeFile !== this.advancedXlsExportAddWorksheetName)) ? this.advancedXlsExportAddWorksheetName : 'Informazioni aggiuntive';
        };
        const newWorksheet = workbook.addWorksheet(name());
        const chiavi = [];
        const chiaviSet = new Set();
        this.advancedXlsExportAddWorksheet.forEach(obj => {
          Object.keys(obj).forEach(key => {
            if (!chiaviSet.has(key)) {
              chiaviSet.add(key);
              chiavi.push(key);
            }
          });
        });
        newWorksheet.columns = chiavi.sort((a, b) => a.localeCompare(b, 'it-IT', { sensitivity: 'base' })).map(k => ({
          header: this.utility.capitalizza(k.replace(/_/g, ' ')),
          key: k
        }));
        for (const riga of this.advancedXlsExportAddWorksheet) {
          newWorksheet.addRow(riga);
        }
        const headerRow = newWorksheet.getRow(1);
        headerRow.font = { color: { argb: '8b0000' }, underline: false };
        headerRow.alignment = { horizontal: 'left' };
        headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'fffbd6' } };

        newWorksheet.columns.forEach(column => {
          let max = 10;
          column.eachCell({ includeEmpty: true }, cell => {
            const text = (cell) => {
              if (cell.value === null || cell.value === undefined) return '';
              if (typeof cell.value === 'object') {
                if (cell.value.richText) {
                  return cell.value.richText.map(part => part.text).join('');
                } else if (cell.value.text) {
                  return cell.value.text;
                } else if (cell.value.result) {
                  return cell.value.result.toString();
                }
                return JSON.stringify(cell.value);
              }
              return cell.value.toString();
            };
            max = Math.max(max, text(cell).length + 2);
          });
          column.width = max;
        });
      }

      workbook.xlsx.writeBuffer().then(async (buffer) => {

        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${filename}.xlsx`);



        that.onEsportatoXls();

      });
    });

  }



  onEsportatoXls() {


    this.spinner.hide();

    this.skip = undefined;

    setTimeout(() => {

      this.isFileAppenaScaricato.next(true);

    }, 1000)

    //this.variabiliDisponibili = [];
    //this.variabiliScelte = [];

    //this.emettiClick.emit(undefined);

  }


  onOptionChanged(evt) {


    //console.warn(evt);

    if (!evt)
      return;

    if (!evt.fullName)
      return;

    let fullNameEvent: string = evt.fullName;

    if (fullNameEvent.endsWith('.sortOrder')) {

      if (fullNameEvent.includes('0')) {


        if (evt.value == 'asc')
          this.variabiliScelte = this.variabiliScelte.sort(
            (a, b) => (a.descrizione as string).localeCompare(b.descrizione as string)
          );


        if (evt.value == 'desc')
          this.variabiliScelte = this.variabiliScelte.sort(
            (a, b) => (a.descrizione as string).localeCompare(b.descrizione as string)
          ).reverse();



      }


    }


    if (fullNameEvent.includes('1')) {


      if (evt.value == 'asc')
        this.variabiliScelte = this.variabiliScelte.sort(
          (a, b) => (a.idSezione as string).localeCompare(b.idSezione as string)
        );


      if (evt.value == 'desc')
        this.variabiliScelte = this.variabiliScelte.sort(
          (a, b) => (a.idSezione as string).localeCompare(b.idSezione as string)
        ).reverse();



    }


  }






  onAllEventStrutturaForm(evt) {





  }

}




